/**
 * @generated SignedSource<<d2bc08c7c90d8fe96203f6925cdaeef5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProblemGeneratorHistoryDialog_problemGeneratorHistory$data = {
  readonly created: any;
  readonly createdBy: {
    readonly name: string;
    readonly picture: string | null;
  };
  readonly difference: {
    readonly __typename: string;
    readonly " $fragmentSpreads": FragmentRefs<"ProblemGeneratorDifferenceCounterLabel_difference" | "ProblemGeneratorDifferenceItemList_difference">;
  } | null;
  readonly " $fragmentType": "ProblemGeneratorHistoryDialog_problemGeneratorHistory";
};
export type ProblemGeneratorHistoryDialog_problemGeneratorHistory$key = {
  readonly " $data"?: ProblemGeneratorHistoryDialog_problemGeneratorHistory$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProblemGeneratorHistoryDialog_problemGeneratorHistory">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProblemGeneratorHistoryDialog_problemGeneratorHistory",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "createdBy",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "picture",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "created",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "difference",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProblemGeneratorDifferenceCounterLabel_difference"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProblemGeneratorDifferenceItemList_difference"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProblemGeneratorHistory",
  "abstractKey": null
};

(node as any).hash = "4dfc5829d1199fc23bef7bee5c478cfd";

export default node;
